import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, ShoppingBag, ClipboardList, RefreshCw, Sparkles } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { useState } from "react";

export default function DemoHome() {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const reset = async () => {
    if (!window.confirm("إعادة تعيين البيانات التجريبية؟")) return;
    setBusy(true);
    try { await api.post("/demo/reset"); toast.success("تمت الإعادة"); }
    catch { toast.error("تعذّر إعادة التعيين"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen brand-soft">
      <header className="max-w-4xl mx-auto flex items-center justify-between px-5 py-5">
        <Link to="/" className="flex items-center gap-2" data-testid="demo-home">
          <div className="w-10 h-10 rounded-2xl brand-grad text-white grid place-items-center font-extrabold">خ</div>
          <div>
            <div className="font-extrabold">خِفّة</div>
            <div className="text-xs text-orange-700 font-bold">النسخة التجريبية</div>
          </div>
        </Link>
        <button onClick={reset} disabled={busy} className="pill text-orange-700 border border-orange-200 bg-white px-3 py-2 text-xs font-bold inline-flex items-center gap-1 disabled:opacity-60" data-testid="demo-reset">
          <RefreshCw size={14}/> إعادة تعيين
        </button>
      </header>

      <main className="max-w-4xl mx-auto px-5 pt-4">
        <div className="rounded-2xl bg-amber-50 border border-amber-200 text-amber-900 px-4 py-3 text-sm mb-6 flex items-start gap-2" data-testid="demo-banner">
          <Sparkles className="mt-0.5 shrink-0" size={18}/>
          <div>
            <div className="font-bold">هذه نسخة تجريبية</div>
            <div className="text-amber-800 mt-0.5">جميع الطلبات والبيانات هنا وهمية لأغراض العرض فقط.</div>
          </div>
        </div>

        <h1 className="text-3xl sm:text-4xl font-extrabold">جرّب النظام</h1>
        <p className="text-gray-600 mt-1">اختر التجربة اللي تحب تستكشفها</p>

        <div className="grid md:grid-cols-2 gap-4 mt-6">
          <button onClick={() => nav("/demo/customer")} className="text-start bg-white rounded-3xl border border-orange-100 card-shadow p-6 group" data-testid="demo-customer-btn">
            <div className="w-14 h-14 rounded-2xl brand-grad text-white grid place-items-center"><ShoppingBag size={26}/></div>
            <div className="mt-4 font-extrabold text-xl">تجربة طلب العميل</div>
            <div className="text-sm text-gray-600 mt-1">تصفّح المنيو، أضف للسلة، اطلب واختَر الاستلام من السيارة.</div>
            <div className="mt-4 inline-flex items-center gap-1 text-orange-700 font-bold text-sm group-hover:gap-2 transition-all">
              ابدأ التجربة <ArrowLeft size={16} className="rotate-180"/>
            </div>
          </button>

          <button onClick={() => nav("/demo/owner")} className="text-start bg-white rounded-3xl border border-orange-100 card-shadow p-6 group" data-testid="demo-owner-btn">
            <div className="w-14 h-14 rounded-2xl bg-gray-900 text-white grid place-items-center"><ClipboardList size={26}/></div>
            <div className="mt-4 font-extrabold text-xl">شاهد لوحة المحل</div>
            <div className="text-sm text-gray-600 mt-1">شاهد كيف يستقبل صاحب المحل الطلبات ويحدّث حالتها بضغطة واحدة.</div>
            <div className="mt-4 inline-flex items-center gap-1 text-orange-700 font-bold text-sm group-hover:gap-2 transition-all">
              افتح اللوحة <ArrowLeft size={16} className="rotate-180"/>
            </div>
          </button>
        </div>

        <div className="mt-8 text-center text-sm text-gray-500">
          هل عندك مطعم حقيقي؟ <Link to="/login" className="text-orange-700 font-bold" data-testid="demo-to-login">دخول المطعم</Link>
        </div>
      </main>
    </div>
  );
}
